<template>
      <!-- Begin page -->
      <div id="wrapper">

            <topbar></topbar>
            <left></left>

            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">

                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">认证专区</h4>

                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                      <li class="breadcrumb-item active">首次认证</li>
                                                </ol>

                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->


                              <div class="row">
                                    <div class="col-12">
                                          <div class="card-box">
                                                <h4 class="m-t-0 header-title" style="border-bottom: 1px solid #868686;padding-bottom: 10px;"><b style="font-size: 15px;margin-bottom: 10px;">第二步：信息认证</b></h4>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000!important;line-height: 30px;margin-bottom:20px;">一、工作经历<br/>
                                                      <code>重要说明：2年以上（含2年）财富管理相关机构工作经验</code>
                                                </p>
                                                <div class="table-responsive">
                                                      <table class="table table-bordered table-striped">
                                                            <thead>
                                                            <tr>
                                                                  <th class="text-center">开始日期</th>
                                                                  <th class="text-center">结束日期</th>
                                                                  <th class="text-center">所在公司</th>
                                                                  <th class="text-center">证明人</th>
                                                                  <th class="text-center">证明人电话</th>
                                                                  <th class="text-center">操作</th>

                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr v-for="item,index in jianli">
                                                                  <td>{{item.start_time}}</td>
                                                                  <td>{{item.over_time}}</td>
                                                                  <td>{{item.company}}</td>
                                                                  <td>{{item.references}}</td>
                                                                  <td>{{item.references_tel}}</td>
                                                                  <td><a href="javascript:void(0)" v-on:click="jianli_del(index)">删除</a></td>
                                                            </tr>
                                                            <tr style="background-color: #ffffff;">
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="start_time" id="start_time"></td>
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="over_time" id="over_time"></td>
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="company"></td>
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="references"></td>
                                                                  <td><input type="text" style="width:100%;height:100%;border:0px;" v-model="references_tel"></td>
                                                                  <td></td>
                                                            </tr>



                                                            </tbody>
                                                      </table>
                                                </div>

                                                <div style="width: 100%;float:left;padding:0px;text-align: right;">
                                                      <button type="submit" style="margin: 0 auto;" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"  v-on:click="jianli_add">+增加工作经历</button>
                                                    <button type="submit" style="margin: 0 auto;" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"  v-on:click="jianli_add">保存</button>
                                                </div>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000!important;line-height: 30px;float:left;margin-bottom:0px;">二、收入证明<br/>
                                                      <code>重要说明：前一自然年度税前收入不低于30万元人民币（以税单或公司开具的收入证明为准）</code></p>

                                                <div class="" style="float: left;padding: 15px 0;width: 100%;color:#000000;">
                                                      认证前一自然年度税前收入
                                                      <input type="text" name="country"
                                                             v-model="shouru"
                                                             class="form-control" style="display:inline;width: 200px;">万元
                                                </div>
                                                <p class="text-muted m-b-30 font-14" style="color: #000000!important;line-height: 30px;float:left;margin-bottom: 10px !important;">上传收入证明<br/>
                                                      <code>请上传上一自然年度的税单或公司开具的收入证明,上传文件大小限制在2.5MB以内，仅支持：jpg、jpeg、png.</code>
                                                </p>
                                                <p style="width: 100%;float: left">
                                                      <!--
                                                      <UploadFile_more  v-bind:status="true"     @getimgurl="fimgurl"  v-for="item in uploadnum" ></UploadFile_more>
                                                      -->
                                                      <UploadFile_more upload_num="99" :jsonimgstr="shouru_images"
                                                                       @getstrfunc="getimg"></UploadFile_more>
                                                </p>
                                                <div style="border:1px solid #cccccc;float:left;padding:1rem;">
                                                      <h4 class="m-t-0 header-title" style="text-align: center;padding-top: 10px;">
                                                            <b style="font-size: 18px;">承诺书</b></h4>
                                                      <p class="text-muted font-14" style="text-indent: 20px;color:#000000 !important;">
                                                            我自愿申请“特许私人财富管理师（CPWM<sup>&#174;</sup>）”资格认证。我了解所有提交的材料须经过特许私人财富管理师认证标准指导委员会的审查。我确认所提交的材料内容真实、准确、完整。
                                                      </p>
                                                      <p class="text-muted font-14" style="text-indent: 20px;color:#000000 !important;">
                                                            本人同意并授权特许私人财富管理师认证标准指导委员会或标准委员会委托的第三方做我本人的工作经历及收入调查，获取与工作经历及收入调查相关的本人信息。本人承诺本人在工作经历及收入调查中所提供的相关信息均真实、完整、有效。

                                                      </p>
                                                      <p class="text-muted font-14" style="text-indent: 20px;color:#000000 !important;">
                                                            本人授权持有或了解我本人有关情况的机构和个人向特许私人财富管理师认证标准指导委员会或标准委员会委托的第三方如实披露工作经历及收入调查所需的所有信息，并免除上述机构和个人在信息提供过程中可能产生的法律责任。
                                                      </p>
                                                </div>
                                                <div class="form-group" style="float: left">
                                                      <div class="form-check">
                                                            <label class="form-check-label" style="padding-top: 20px;font-weight: bold;">
                                                                  <input class="form-check-input" type="checkbox" v-model="checkedyouknow" >
                                                                  <span >我已经阅读并认可《承诺书》</span>
                                                            </label>
                                                      </div>
                                                </div>
                                                <div style="width: 100%;float:left;padding:20px;text-align: right;">
                                                      <button type="submit" style="margin: 0 auto;" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"  v-on:click="add">提交申请</button>
                                                </div>
                                                <div style="clear: both"></div>
                                                <!-- end row -->

                                          </div> <!-- end card-box -->
                                    </div><!-- end col -->
                              </div>
                              <!-- end row -->


                        </div> <!-- container -->

                  </div> <!-- content -->

                  <!--footer-->

            </div>

      </div>


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      import UploadFile from "./UploadFile";
      import UploadFile_more from "./UploadFile_more";

      export default {
            components: {topbar,left,UploadFile,UploadFile_more},
            data() {
                  return {
                        jianli:this.jianli,
                        shouru:this.shouru,
                        shouru_images:this.shouru_images,

                        start_time:this.start_time,
                        over_time:this.over_time,
                        company:this.company,
                        references:this.references,
                        references_tel:this.references_tel,

                        uploadnum:1, //上传数量
                  }
            },

            created() {
                  this.jianli = [];
                  //时间日期
                  layui.use('laydate', function() {
                        var laydate = layui.laydate;
                        laydate.render({
                              elem: '#start_time' //指定元素
                              ,type: 'date'
                              ,theme: 'molv'
                              //,value: ''
                              ,isInitValue: true
                              //,range: true
                              ,trigger: 'click',
                              done: value =>{
                                    this.start_time=value;
                              }


                        });

                        laydate.render({
                              elem: '#over_time' //指定元素
                              ,type: 'date'
                              ,theme: 'molv'
                              //,value: ''
                              ,isInitValue: true
                              //,range: true
                              ,trigger: 'click',

                          max:"new Date()",

                              done: value =>{
                                    this.over_time=value;
                              },





                        });
                  }.bind(this));
                  this.Authentication_show();
                  this.show();
            },
            methods: {
                  jianli_add:function(){
                        console.log(this.start_time);
                        let s=new Date(this.start_time);
                        let o=new Date(this.over_time);
                        if(this.start_time!=undefined && this.over_time!=undefined && this.company!=undefined && this.references!=undefined && this.references_tel!=undefined && this.start_time!='' && this.over_time!='' && this.company!='' && this.references!='' && this.references_tel!='' ){
                              if(s>o){
                                    swal(
                                          {
                                                title: '结束日期要晚于开始时间',
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }else{
                                    this.jianli.push({"start_time": this.start_time, "over_time": this.over_time, "company": this.company, "references": this.references, "references_tel": this.references_tel});
                                    this.start_time=undefined;
                                    this.over_time=undefined;
                                    this.company=undefined;
                                    this.references=undefined;
                                    this.references_tel=undefined;
                              }


                        }else{
                              swal(
                                    {
                                          title: '工作经历填写不完整',
                                          text: '',
                                          type: 'error',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                        }


                  },
                  add: function () {
                        let checkedyouknow = this.checkedyouknow;
                        if (!checkedyouknow) {
                              swal(
                                    {
                                          title: '请阅读并认可《承诺书》之后，提交认证申请。',
                                          text: '',
                                          type: 'error',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                              return false;
                        }
                        if(this.jianli.length==0){
                              swal(
                                    {
                                          title: '工作经历不能为空',
                                          text: '',
                                          type: 'error',
                                          confirmButtonColor: '#4fa7f3',
                                    }
                              )
                              return false;
                        }
                        let data = {
                              jianli: this.jianli,
                              shouru: this.shouru,
                              shouru_images:this.shouru_images,
                        }
                        this.$axios({
                              method: "POST",
                              url: '/api/member2/Authentication_add',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                                    if (response.data.code == 0) {
                                          /*
                                          swal(
                                                {
                                                      title: response.data.msg,
                                                      text: '',
                                                      type: 'success',
                                                      confirmButtonColor: '#4fa7f3',
                                                }
                                          )

                                           */
                                          window.location.href="/member2/#/Authentication";
                                          //window.location.href="/member2/#/Authentication_pay?id="+response.data.backid;
                                    } else {
                                          swal(
                                                {
                                                      title: response.data.msg,
                                                      text: '',
                                                      type: 'error',
                                                      confirmButtonColor: '#4fa7f3',
                                                }
                                          )
                                    }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  Authentication_show: function () {

                        this.$axios({
                              method: "get",
                              url: '/api/member2/Authentication_show',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              //console.log(response.data.jianli);
                              if(response.data.jianli!=undefined){
                                    this.jianli=response.data.jianli;
                                    this.shouru=response.data.shouru;
                                    this.shouru_images=response.data.shouru_images;
                              }
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  jianli_del:function(index){
                        this.jianli.splice(index,1);
                        //console.log(index)
                  },
                  /*
                  fimage(url){
                        this.shouru_images=url;
                  },

                   */
                  fimgurl(url){
                        this.uploadnum=this.uploadnum+1;
                        this.shouru_images=url+','+this.shouru_images;
                        //console.log(this.shouru_images);
                  },
                  getimg: function (url) {
                        this.shouru_images = url;
                  },
                  show: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/Authentication_status',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              if (response.data.code == 1) {
                                    window.location.href = '#/Authentication_show?key=' + response.data.msg;
                              } else if (response.data.code == 2) {
                                    //这里是流程正在走
                                    if (response.data.status == 1) {
                                          window.location.href = '#/Authentication_pay?id=' + response.data.recordid;
                                    } else {
                                          let str = '';
                                          if (response.data.status == 0) {
                                                str = '您已成功提交首次认证申请。工作人员将在十个工作日内审核完成，请及时关注审核结果。';
                                                window.location.href = '#/Authentication_show?key=' + str;
                                          }
                                          if (response.data.status == 3) {
                                                if (response.data.province == null) {
                                                      //已经付款但是没填写发票地址
                                                      window.location.href = '#/Authentication_fapiao?out_trade_no=' + response.data.orderid;
                                                } else {
                                                      //已付款等待证书。
                                                      str = '1';
                                                      window.location.href = '#/Authentication_show?key=' + str;
                                                }
                                                //console.log(response.data.title);
                                          }
                                          if (response.data.status == 4) {
                                                //证书已经邮寄
                                                str = '2';
                                                window.location.href = '#/Authentication_show?key=' + str;
                                          }

                                    }


                              }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  //method over

            }
            //mounted over


      }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx {
            width: 100%;
      }

      .zx li {
            width: 100%;
            float: left
      }
      code{background-color: #ffffff !important;}


</style>



// WEBPACK FOOTER //
// src/components/Authentication_step2.vue